import { UserProfile } from '@providers/api/user/user.data.interface';
import { QuestionnaireTenxForm } from './tenx.interface';
import {
  qUtilsTenxFilterDefaultOption,
  qUtilsTenxFindDefaultOption
} from './tenx.utils';

/**
 * @description Questionnaire Tenx State.
 * @exports
 * @interface QuestionnaireTenxState
 */
export interface QuestionnaireTenxState {
  form: QuestionnaireTenxForm;
  userProfile: UserProfile | null;
  loading: {
    submit: boolean;
    fetchUserProfile: boolean;
  };
  submissionResponse: {
    success: boolean | null;
    message?: string | null;
    response: any | null;
  };
}

/**
 * @description Initial state for Questionnaire Tenx.
 * @returns {QuestionnaireTenxState}
 */
export const intialQuestionnaireTenxState = (): QuestionnaireTenxState => ({
  userProfile: null,
  form: {
    information: {
      weight: null,
      height: null
    },
    sleepHabits: {
      sleepEachNightOnAverage: qUtilsTenxFindDefaultOption(
        'sleepHabits.sleepEachNightOnAverage'
      ),
      wakeUpInMiddleSleepEachNight: null
    },
    exerciseLevelPerWeekCompletedName: '',
    smokingHabits: {
      startSmoking: qUtilsTenxFindDefaultOption('smokingHabits.startSmoking'),
      smokingStatus: qUtilsTenxFindDefaultOption('smokingHabits.smokingStatus'),
      dailyConsumption: qUtilsTenxFindDefaultOption(
        'smokingHabits.dailyConsumption'
      ),
      cigarettesType: qUtilsTenxFilterDefaultOption(
        'smokingHabits.cigarettesType'
      )
    },
    alcoholHabits: {
      alcoholStatus: qUtilsTenxFindDefaultOption('alcoholHabits.alcoholStatus'),
      amountOfAlcohol: qUtilsTenxFindDefaultOption(
        'alcoholHabits.amountOfAlcohol'
      ),
      startConsumeAlcohol: qUtilsTenxFindDefaultOption(
        'alcoholHabits.startConsumeAlcohol'
      ),
      typeOfAlcohol: qUtilsTenxFilterDefaultOption(
        'alcoholHabits.typeOfAlcohol'
      )
    },
    allergies: qUtilsTenxFilterDefaultOption('allergies'),
    vaccinations: qUtilsTenxFilterDefaultOption('vaccinations'),
    exerciseLevelPerWeek: qUtilsTenxFindDefaultOption('exerciseLevelPerWeek'),
    medications: qUtilsTenxFilterDefaultOption('medications'),
    medicalHistory: qUtilsTenxFilterDefaultOption('medicalHistory'),
    fatherMedicalHistory: qUtilsTenxFilterDefaultOption('fatherMedicalHistory'),
    motherMedicalHistory: qUtilsTenxFilterDefaultOption('motherMedicalHistory'),
    surgicalHistory: qUtilsTenxFindDefaultOption('surgicalHistory'),
    conditionalAllergies: qUtilsTenxFilterDefaultOption('conditionalAllergies')
  },
  loading: {
    submit: false,
    fetchUserProfile: false
  },
  submissionResponse: {
    success: null,
    message: null,
    response: null
  }
});

export const questionnaireTenxKey = 'questionnaire-tenx';
export const questionnaireTenxState: QuestionnaireTenxState =
  intialQuestionnaireTenxState();
